export enum UserRoleType {
  STUDENT = "student",
  AUTHOR = "author",
}
